
import { reactive, computed } from 'vue';

import { storedRef } from './utils.js';

const activity = 2;

export const questions = [ {

  id: `activity-${ activity }-question-1`,

  question: 'Would you recommend a trip to Shenandoah National Park to your family and friends? Why or why not?',

  answer: storedRef( activity, 'answer-1', null )

} ];

export const selectedRoute = storedRef( activity, 'selected-route', null );

export const selectedGas = storedRef( activity, 'selected-gas', null );

export const selectedFood = storedRef( activity, 'selected-food', null );

export const selectedResponse = storedRef( activity, 'selected-response', null );

export const seenPlayerDialog = storedRef( activity, 'seen-player-dialog', false );

export const hasDownloaded = storedRef( activity, 'has-downloaded', false );

export const parts = reactive( {
    
  1: {
    
    subtitle: 'Packing Up the Car',

    description: 'Learn about all the extra supplies African Americans needed to travel with during the Jim Crow era.'

  },
  
  2: {
    
    subtitle: 'Choose a Route',

    description: computed( () =>

      selectedRoute.value === 'a' ? 'You selected Route A through Washington DC and Gainesville.' :
      
      selectedRoute.value === 'b' ? 'You selected Route B through Frederick and Harpers Ferry.' :
      
      '' )

  },

  3: {
    
    subtitle: 'Stop for Gas',

    description: computed( () =>

      selectedRoute.value === 'a' && selectedGas.value === 'book' ? 'You found a service station in your Green Book.' :
      
      selectedRoute.value === 'b' && selectedGas.value === 'book' ? 'No service stations were found. You stopped at the first station you saw, but were refused service.' :
      
      selectedGas.value === 'first' ? 'You stopped at the first station you saw, but were refused service.' :
      
      '' )

  },

  4: {
    
    subtitle: 'Arriving at Shenandoah',

    description: 'A ranger directed you to Lewis Mountain, even though other spaces in the Park were integrated.'

  },

  5: {
    
    subtitle: 'Where to Eat',

    description: computed( () =>

      selectedFood.value === 'pinnacles' ? 'You chose Pinnacles Picnic Grounds and saw that all races were eating there.' :
      
      selectedFood.value === 'panorama' ? 'Panorama\'s \'colored area\' was not equal to the area for whites. You go to Pinnacles instead.' :
      
      '' )

  },

  6: {
    
    subtitle: 'At the picnic area',

    description: computed( () =>

      selectedResponse.value === 'stay' ? 'A ranger defused a situation and your family finishes their lunch.' :
      
      selectedResponse.value === 'leave' ? 'You pack up and leave to avoid trouble.' :
      
      '' )

  },

  7: {
    
    subtitle: 'Reflection',

    description: 'Think about your journey and experiences at Lewis Mountain, then make a recommendation about visiting Shenandoah.'

  }

} );
